<template>
  <section id="overviewSection" class="scroll-snap-section">
    <div class="align-items-start">
      <div class="d-flex align-items-center gap-3 mb-5">
        <img v-if="sharingStore.photo" :src="sharingStore.photo" class="img-thumbnail d-block avtar-100"
          alt="profile image">
        <h1 class="m-0">{{ sharingStore.name }}'s Ancestry</h1>
      </div>
      <p><strong>These are <span>{{ sharingStore.name.split(" ")[0] }}'s ancestry results</span>. This is a public
          summary of their results which
          they
          have
          chosen
          to share with their friends and family</strong></p>
      <p>Living DNA is a leading genetics company providing a detailed regional and subregion view of your
        ancestry. Using a simple mouth swab and custom built ancestry panels to provide detailed ancestry
        results
        stored in a secure online portal. Your ancestry results combine your autosomal DNA results with
        your
        motherline and fatherline (for genetic males) results.</p>
      <p>These results help you to uncover the history of your ancestors to discover the context of their
        migrations up to 10 generations back. Pin point moments in time where your ancestors lived and
        discover
        the regions that shape who you have become today.</p>
      <a href="#explore" class="btn btn-outline-primary">Unlock your story</a>
    </div>
  </section>
  <section class="my-5 breakdown-section">
    <div class="card mb-4 card-grey">
      <div class="card-body d-md-flex align-items-center">
        <div>
          <h6 class="card-subtitle mb-2 text-muted mb-4">Regional breakdown</h6>
          <div>
            <p class="d-flex gap-3 align-items-center" v-for="(value, index) in chartData.datasets[0].data"
              :key="index">
              <span class="badge-circular"
                :style="{ background: chartData.datasets && chartData.datasets[0] && chartData.datasets[0].backgroundColor[index] ? chartData.datasets[0].backgroundColor[index] : 'defaultColor' }">
              </span>
              {{ chartData.labels[index] }}
              <span>{{ value.toFixed(1) }}%</span>
            </p>
          </div>
        </div>
        <div class="ms-auto">
          <Doughnut :data="chartData" :options="chartOptions" />
        </div>
      </div>
    </div>
    <div class="grid grid-cols-2 gap-6 mt-5">
      <div v-if="sharingStore.motherlineResult" class="card card-maternal border-red">
        <div class="card-body">

          <p class="card-text">Maternal haplogroup</p>
          <h5 class="card-title text-red">{{ sharingStore.motherlineResult.haplogroup }}</h5>

          <p v-if="sharingStore.motherlineResult.subclade" class="card-text mt-4">Maternal haplotype</p>
          <h5 v-if="sharingStore.motherlineResult.subclade" class="card-title text-red">{{
            sharingStore.motherlineResult.subclade }}</h5>

          <a href="#motherline">
            <h6 class="card-subtitle mt-3 text-red">Motherline </h6>
          </a>
        </div>
      </div>

      <div v-if="sharingStore.fatherlineResult" class="card card-maternal border-blue">
        <div class="card-body">
          <p class="card-text">Paternal haplogroup</p>
          <h5 class="card-title text-blue">{{ sharingStore.fatherlineResult.haplogroup }}</h5>
          <p v-if="sharingStore.fatherlineResult.subclade" class="card-text mt-4">Paternal haplotype</p>
          <h5 v-if="sharingStore.fatherlineResult.subclade" class="card-title text-blue">{{
            sharingStore.fatherlineResult.subclade }}</h5>
          <a href="#fatherline">
            <h6 class="card-subtitle mt-3 text-blue">Fatherline</h6>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>
<script setup>
import { useSharingStore } from "@/store/sharing";
const sharingStore = useSharingStore();
import { Doughnut } from 'vue-chartjs';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const chartData = {
  labels: [],
  datasets: [
    {
      label: 'Ancestry Distribution',
      data: [],
      backgroundColor: [],
    }
  ]
};

sharingStore.regions.forEach((region) => {
  chartData.labels.push(region.title);
  chartData.datasets[0].data.push(region.percentage);
  chartData.datasets[0].backgroundColor.push(region.colour);
});

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: false
  },
};
</script>